<template>
  <article class="novel-card">
    <button class="novel-main" data-analytics="novel.open" @click="$emit('open', novel.id)">
      <span class="novel-cover">
        <img :src="novel.cover_url" :alt="novel.title" loading="lazy">
        <em>{{ badgeLabel(novel.badge) }}</em>
        <b v-if="novel.progress" :style="{ width: `${novel.progress.position_percent}%` }" />
      </span>
      <span class="novel-copy">
        <strong>{{ novel.title }}</strong>
        <small>{{ novel.author }}</small>
        <p>{{ novel.description }}</p>
        <em>{{ novel.category_name }} · {{ $t(novel.serial_status === "finished" ? "discoverUi.finished" : "discoverUi.serializing") }} · {{ novel.pay_status === "free" ? $t("discoverUi.free") : "VIP" }}</em>
        <i>{{ latestChapter }}</i>
      </span>
    </button>
    <button class="novel-collect" :class="{ active: novel.collected }" :aria-label="$t(novel.collected ? 'a11y.removeBookshelf' : 'a11y.addBookshelf')" data-analytics="novel.bookshelf_toggle" @click="$emit('collect', novel)">
      <i :class="novel.collected ? 'el-icon-star-on' : 'el-icon-star-off'" />
    </button>
  </article>
</template>

<script>
export default {
  name: "NovelCard",
  props: {
    novel: { type: Object, required: true }
  },
  computed: {
    latestChapter() {
      return this.$locale.language === "zh-CN" ? this.novel.latest_chapter_name : this.$t("discoverUi.latestChapter", { count: this.novel.chapter_count })
    }
  },
  methods: {
    badgeLabel(value) {
      if (value === "免费") return this.$t("discoverUi.free")
      const key = { "热": "hot", "热读": "popularRead", "新": "new", "新书": "newBook", "独家": "exclusive", "独播": "exclusive", "完结": "finished", "爆款": "hit", "限免": "limitedFree", "今日更新": "updatedToday" }[value]
      return key ? this.$t(`discoverBadge.${key}`) : value
    }
  }
}
</script>
